import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import moment from "moment";
import FETCH from "../../../utils/fetch";
import { MODULE_API } from "../../../apis";
import DEATH_API from "../../../apis/death.api";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import manageIcon from "../../../assets/images/logoForPlaid.png";
import Loader from "../../../components/styled-components/loader/loader";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import List from "../../styledComponents/Table/List";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import { Table } from "antd";
import "../LiabilityDashboard.css";
import { useSelector } from "react-redux";

export const CreditTable = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const refreshTime = useSelector(
    (state) => state.rootReducer.itemsInfo.refreshTimeAsset
  );
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const Creditscols = [
    {
      title: "Name of Liability",
      dataIndex: "Nickname of Liabilities",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Owner",
      dataIndex: "Owner",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Financial Institution",
      dataIndex: "Name of Financial Institution",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Monthly Payment",
      dataIndex: "Monthly Payment",
      render: (record) =>
        record
          ? !isNaN(record)
            ? // ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              `$${parseFloat(record)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },

    {
      title: "Interest Rate(%APR)",
      dataIndex: "Interest Rate",
      render: (record) => (record ? `${record + "%"} ` : "N/A"),
    },
    {
      title: "Maturity Date",
      dataIndex: "Maturity Date",
      render: (record) =>
        record ? moment(record).format("MM/DD/YYYY") : "N/A",
    },
    {
      title: "Loan Balance",
      dataIndex: "Loan Balance",
      render: (record,row) =>{
        const value = row && row["Loan Balance"] || row["Initial Loan Amount"];
        return value
          ? !isNaN(value)
            ? `${"$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A";
      }
    },

    {
      title: "Action",
      render: (record, index) => {
        return (
          <div style={{ display: "flex" }} key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}>
              <img src={menuIcon} alt="menuIcon" height={15} width={4}></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}></div>

                <div class="dropdown" style={{ zIndex: "9999", width: "16%" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        fnView(record);
                        setDropdown(false);
                      }}>
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{
                      //   opacity: record.managedBy === "Plaid" ? "0.3" : "1",
                      //   cursor:
                      //     record.managedBy === "Plaid"
                      //       ? "not-allowed"
                      //       : "pointer",
                      //   pointerEvents:
                      //     record.managedBy === "Plaid" ? "none" : "",
                      // }}
                      onClick={() => {
                        fnEdit(record);
                        setDropdown(false);
                      }}>
                      Update
                    </li>
                    <li
                      className="liHover"
                      // style={{
                      //   opacity: record.managedBy === "Plaid" ? "0.3" : "1",
                      //   cursor:
                      //     record.managedBy === "Plaid"
                      //       ? "not-allowed"
                      //       : "pointer",
                      //   pointerEvents:
                      //     record.managedBy === "Plaid" ? "none" : "",
                      // }}
                      onClick={() => {
                        deletePost(record.id, record.managedBy, record);
                        setDropdown(false);
                      }}>
                      Delete
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
            {record.managedBy === "Plaid" && (
            <div className="managed-by-plaid-icon"> </div>
            
            )}
          </div>
        );
      },
    },
  ];
  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  const deleteLinkTransactions = async (id, record) => {
    await swal({
      title: "Are you sure?",
      text: `Are you sure you want to delete ${
        record["Nickname of Liabilities"]
          ? record["Nickname of Liabilities"]
          : "Liability"
      } ? All Transactions in Budget will be deleted as well.`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          setLoading(true);
          let payload = {
            cmId: id,
          };
          const resposnse = await DEATH_API.deleteLinkTransactions(payload);
          if (resposnse && resposnse.status === 200) {
            swal("Success", resposnse.message, "success");
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      } else {
        swal("Cancelled", "Your Transactions are safe :)", "error");
      }
    });
  };
  const deletePost = async (id, managedBy, recordToDelete) => {
    console.log("delete is", id);
    await swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        setLoading(true);
        try {
          if (managedBy === "Plaid") {
            await deleteLinkTransactions(id, recordToDelete);
          }
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });
          // if (res && res.status === 200 && managedBy === "Plaid") {
          //   deleteLinkTransactions(id, recordToDelete);
          // }
          // setLiabilitesCredit([]);
          // setCreditRows([]);
          setLoading(false);
          props.updateSharedState(!props.sharedState);
        } catch (error) {
          setLoading(false);
        }
      }
    });
  };

  const fnEdit = (record) => {
    history.push(
      `/liabilities_credit_new/attributes/${record.module}/${record.id}`
    );
  };
  const fnView = (record) => {
    history.push(
      `/liabilities_credit_new/attributes/${record.module}/${record.id}/view`
    );
  };

  const options = {
    plugins: {
      datalabels: {
        display: true,
        color: "white",
        formatter: (value, context) => `${value}%`,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          stacked: true,
        },
      ],
      yAxes: [
        {
          stacked: true,
          ticks: {
            callback: function (value) {
              return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(value);
            },
          },
        },
      ],
    },
    tooltips: {
      // enabled: false,
      callbacks: {
        label: (tooltipItem, data) => {
          // Get the dataset label, global label or fall back to empty label
          let label =
            (data.datasets[tooltipItem.datasetIndex].labels &&
              data.datasets[tooltipItem.datasetIndex].labels[
                tooltipItem.index
              ]) ||
            data.datasets[tooltipItem.datasetIndex].label ||
            data.labels[tooltipItem.index] ||
            "";
          if (label) {
            label += ": ";
          }

          // Apply the value and suffix
          label +=
            data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] +
            (data.datasets[tooltipItem.datasetIndex].labelSuffix || "");

          return label;
        },
      },
    },
    legend: {
      onClick: () => {}, // Disable legend click
    },
  };

  const data = {
    labels: props.uniqueModules && props.uniqueModules,
    datasets: [
      {
        label: "Credit Balance",
        data: props.creditBalance && props.creditBalance,
        backgroundColor: "#B1E3FF",
      },
      {
        label: "Credit Limit",
        data: props.creditLimit && props.creditLimit,
        backgroundColor: "#2A3DA3",
      },
    ],
  };
  const upgrade = () => {
    history.push("/payment");
  };
  const refresh = async () => {
    await props.refreshModule();
    props.updateSharedState(!props.sharedState);
  };
  const handleButtonClick = () => {
    swal({
      title: "Please Upgrade for complete experience",
      text: "Your level of subscription only allows Refresh of non-linked Assets.",
      icon: "warning",
      type: "warning",
      buttons: {
        upgrade: {
          text: "Upgrade",
          value: "upgrade",
          visible: true,
        },
        ok: {
          text: "Ok",
          value: "ok",
          visible: true,
        },
        cancel: {
          text: "Cancel",
          value: "cancel",
          visible: true,
          closeModal: true,
        },
      },
    }).then((value) => {
      console.log("Button value clicked:", value); // Debugging line to show the value
      switch (value) {
        case "upgrade":
          console.log("calling upgrade");
          upgrade();
          break;

        case "ok":
          console.log("calling Simple");
          refresh();
          break;

        case "cancel":
          console.log("Cancel button clicked");
          // Add your cancel logic here, if needed
          break;

        default:
          console.log("No action taken");
          break;
      }
    });
  };
  return (
    <React.Fragment>
      <div
        className="creditDebtCard"
        style={{
          display:
            props.creditRows && props.creditRows.length > 0 ? "flex" : "block",
          flexDirection:
            props.creditRows && props.creditRows.length > 0
              ? "column"
              : "column",
          flexGrow: props.creditRows && props.creditRows.length > 0 ? "1" : "0",
        }}>
        <h3 className="liablitycardheading">Debt Information</h3>
        {props.creditRows && props.creditRows.length > 0 ? (
          <div style={{ marginTop: "2rem", display: "flex", flexGrow: "1" }}>
            <Bar data={data} options={options} height={400} width={400} />
          </div>
        ) : (
          <div
            style={{
              marginTop: "2rem",
              display: "flex",
              flexGrow: "1",
              alignItems: "center",
              justifyContent: "center",
            }}>
            No Chart data to show
          </div>
        )}
      </div>
      <div className="creditDebtCard2" style={{ position: "relative" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}>
          <h3 className="liablitycardheading">Loans (Not Credit Cards)</h3>
          {userRole && userRole !== "FreeTrail" && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "space-between",
                gap: "1rem",
                color: "black",
              }}>
              <button
                className="addbuttonLiablity"
                style={{ paddingInline: "1rem" }}
                onClick={() => {
                  refresh();
                  // handleButtonClick();
                }}>
                {" "}
                Refresh
              </button>
              {refreshTime &&
                `Updated at: ${moment(refreshTime)
                  .local()
                  .format("MM/DD/YYYY [at] hh:mmA")}`}
            </div>
          )}
        </div>
        {/* <List cols={Creditscols} rows={props.liabilitiesCredit && props.liabilitiesCredit} /> */}
        <Table
          columns={Creditscols}
          dataSource={props.liabilitiesCredit && props.liabilitiesCredit}
          pagination={{
            total: props.totalPages * 10, // Assuming 10 items per page
            current: props.currentPage,
            onChange: (page) => {
              props.setCurrentPage(page);
            },
            pageSize: 10, // Number of items per page
          }}
        />
        <NewLoader isLoading={props.loading || loading} />
      </div>
    </React.Fragment>
  );
};
